<template>
    <div class="member-account-set" v-if="user">
        <div class="common-header-wrap">
            <mt-header title="إعدادت الحساب" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="menu-list">
            <div v-show="(user.member_mobilebind && user.member_mobile) || (user.member_emailbind && user.member_email)" @click='popupVisible("password")'><mt-cell class="menu-item" title="تغيير كلمة المرور" ><span class="iconfont right-arrow">&#xe600;</span></mt-cell></div>
            <div v-show="(user.member_mobilebind && user.member_mobile) || (user.member_emailbind && user.member_email)" @click='popupVisible("paypwd")'><mt-cell class="menu-item" title="تغيير كلمة مرور الدفع" ><span class="iconfont right-arrow">&#xe600;</span></mt-cell></div>
            <div @click='popupVisible("mobile")'><mt-cell class="menu-item" :title="(user.member_mobilebind?'تعديل':'ربط')+' الهاتف الخلوي'">{{user.member_mobile}}<span class="iconfont right-arrow">&#xe600;</span></mt-cell></div>
            <div @click='popupVisible("email")'><mt-cell class="menu-item" :title="(user.member_emailbind?'تعديل':'ربط')+' صندوق البريد'">{{user.member_email}}<span class="iconfont right-arrow">&#xe600;</span></mt-cell></div>
        </div>
        <mt-button class="ds-button-large mt-10" type="primary" @click="logout">خروج</mt-button>

        <!--修改手机-->
        <mt-popup v-model="editMobileVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header :title="(user.member_mobilebind?'تعديل':'ربط')+' الهاتف الخلوي'" class="common-header">
                    <mt-button slot="left" icon="back" @click="editMobileVisible=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">

                <div class="national_code_box">
                  <div class="box_dt">رمز المنطقة الدولية</div>
                  <div class="box_dd">
                    <select class="national_code" v-model="nationalcode" id="national_code" name="nationalCode">
                      <option value="1">+1 Canada</option>
                      <option value="1">
                        +1 Saint Kitts and Nevis
                      </option>
                      <option value="1">
                        +1 Saint Lucia
                      </option>
                      <option value="1">
                        +1 Saint Vincent and the Grenadines
                      </option>
                      <option value="1">
                        +1 United States
                      </option>
                      <option value="1">
                        +1 United States Minor Outlying Islands
                      </option>
                      <option value="1-242">
                        +1-242 Bahamas
                      </option>
                      <option value="1-246">
                        +1-246 Barbados
                      </option>
                      <option value="1-264">
                        +1-264 Anguilla
                      </option>
                      <option value="1-268">
                        +1-268 Antigua and Barbuda
                      </option>
                      <option value="1-284">
                        +1-284 British Indian Ocean Territory
                      </option>
                      <option value="1-345">
                        +1-345 Cayman Islands
                      </option>
                      <option value="1-441">
                        +1-441 Bermuda
                      </option>
                      <option value="1-473">
                        +1-473 Grenada
                      </option>
                      <option value="1-649">
                        +1-649 Turks and Caicos Islands
                      </option>
                      <option value="1-664">
                        +1-664 Montserrat
                      </option>
                      <option value="1-671">
                        +1-671 Guam
                      </option>
                      <option value="1-767">
                        +1-767 Dominica
                      </option>
                      <option value="1-787">
                        +1-787 Puerto Rico
                      </option>
                      <option value="1-809">
                        +1-809 Dominican Republic
                      </option>
                      <option value="1-868">
                        +1-868 Trinidad and Tobago
                      </option>
                      <option value="1-876">
                        +1-876 Jamaica
                      </option>
                      <option value="1284">
                        +1284 Virgin Islands (British)
                      </option>
                      <option value="1340">
                        +1340 Virgin Islands (U.S.)
                      </option>
                      <option value="1670">
                        +1670 Northern Mariana Islands
                      </option>
                      <option value="20">
                        +20 Egypt
                      </option>
                      <option value="212">
                        +212 Morocco
                      </option>
                      <option value="213">
                        +213 Algeria
                      </option>
                      <option value="216">
                        +216 Tunisia
                      </option>
                      <option value="218">
                        +218 Libya
                      </option>
                      <option value="220">
                        +220 Gambia
                      </option>
                      <option value="221">
                        +221 Senegal
                      </option>
                      <option value="222">
                        +222 Mauritania
                      </option>
                      <option value="223">
                        +223 Mali
                      </option>
                      <option value="224">
                        +224 Guinea
                      </option>
                      <option value="225">
                        +225 Cote D'Ivoire
                      </option>
                      <option value="226">
                        +226 Burkina Faso
                      </option>
                      <option value="227">
                        +227 Niger
                      </option>
                      <option value="228">
                        +228 Togo
                      </option>
                      <option value="229">
                        +229 Benin
                      </option>
                      <option value="230">
                        +230 Mauritius
                      </option>
                      <option value="231">
                        +231 Liberia
                      </option>
                      <option value="232">
                        +232 Sierra Leone
                      </option>
                      <option value="233">
                        +233 Ghana
                      </option>
                      <option value="234">
                        +234 Nigeria
                      </option>
                      <option value="235">
                        +235 Chad
                      </option>
                      <option value="236">
                        +236 Central African Republic
                      </option>
                      <option value="237">
                        +237 Cameroon
                      </option>
                      <option value="238">
                        +238 Cape Verde
                      </option>
                      <option value="239">
                        +239 Sao Tome and Principe
                      </option>
                      <option value="240">
                        +240 Equatorial Guinea
                      </option>
                      <option value="241">
                        +241 Gabon
                      </option>
                      <option value="242">
                        +242 Congo, The Republic of Congo
                      </option>
                      <option value="243">
                        +243 Congo, The Democratic Republic Of The
                      </option>
                      <option value="244">
                        +244 Angola
                      </option>
                      <option value="245">
                        +245 Guinea-Bissau
                      </option>
                      <option value="247">
                        +247 Ascension Island
                      </option>
                      <option value="248">
                        +248 Seychelles
                      </option>
                      <option value="249">
                        +249 Sudan
                      </option>
                      <option value="250">
                        +250 Rwanda
                      </option>
                      <option value="251">
                        +251 Ethiopia
                      </option>
                      <option value="252">
                        +252 Somalia
                      </option>
                      <option value="253">
                        +253 Djibouti
                      </option>
                      <option value="254">
                        +254 Kenya
                      </option>
                      <option value="255">
                        +255 Tanzania
                      </option>
                      <option value="255">
                        +255 Zanzibar
                      </option>
                      <option value="256">
                        +256 Uganda
                      </option>
                      <option value="257">
                        +257 Burundi
                      </option>
                      <option value="258">
                        +258 Mozambique
                      </option>
                      <option value="260">
                        +260 Zambia
                      </option>
                      <option value="261">
                        +261 Madagascar
                      </option>
                      <option value="262">
                        +262 Reunion
                      </option>
                      <option value="263">
                        +263 Zimbabwe
                      </option>
                      <option value="264">
                        +264 Namibia
                      </option>
                      <option value="265">
                        +265 Malawi
                      </option>
                      <option value="266">
                        +266 Lesotho
                      </option>
                      <option value="267">
                        +267 Botswana
                      </option>
                      <option value="268">
                        +268 Swaziland
                      </option>
                      <option value="269">
                        +269 Comoros
                      </option>
                      <option value="269">
                        +269 Mayotte
                      </option>
                      <option value="27">
                        +27 South Africa
                      </option>
                      <option value="290">
                        +290 St. Helena
                      </option>
                      <option value="291">
                        +291 Eritrea
                      </option>
                      <option value="297">
                        +297 Aruba
                      </option>
                      <option value="298">
                        +298 Faroe Islands
                      </option>
                      <option value="299">
                        +299 Greenland
                      </option>
                      <option value="30">
                        +30 Greece
                      </option>
                      <option value="31">
                        +31 Netherlands
                      </option>
                      <option value="32">
                        +32 Belgium
                      </option>
                      <option value="33">
                        +33 France
                      </option>
                      <option value="33">
                        +33 France Metropolitan
                      </option>
                      <option value="33">
                        +33 French Southern Territories
                      </option>
                      <option value="34">
                        +34 Spain
                      </option>
                      <option value="350">
                        +350 Gibraltar
                      </option>
                      <option value="351">
                        +351 Portugal
                      </option>
                      <option value="352">
                        +352 Luxembourg
                      </option>
                      <option value="353">
                        +353 Ireland
                      </option>
                      <option value="354">
                        +354 Iceland
                      </option>
                      <option value="355">
                        +355 Albania
                      </option>
                      <option value="356">
                        +356 Malta
                      </option>
                      <option value="357">
                        +357 Cyprus
                      </option>
                      <option value="358">
                        +358 Aland Islands
                      </option>
                      <option value="358">
                        +358 Finland
                      </option>
                      <option value="359">
                        +359 Bulgaria
                      </option>
                      <option value="36">
                        +36 Hungary
                      </option>
                      <option value="370">
                        +370 Lithuania
                      </option>
                      <option value="371">
                        +371 Latvia
                      </option>
                      <option value="372">
                        +372 Estonia
                      </option>
                      <option value="373">
                        +373 Moldova
                      </option>
                      <option value="374">
                        +374 Armenia
                      </option>
                      <option value="375">
                        +375 Belarus
                      </option>
                      <option value="376">
                        +376 Andorra
                      </option>
                      <option value="377">
                        +377 Monaco
                      </option>
                      <option value="378">
                        +378 San Marino
                      </option>
                      <option value="380">
                        +380 Ukraine
                      </option>
                      <option value="381">
                        +381 Kosovo
                      </option>
                      <option value="381">
                        +381 Serbia
                      </option>
                      <option value="381">
                        +381 Yugoslavia
                      </option>
                      <option value="382">
                        +382 Montenegro
                      </option>
                      <option value="385">
                        +385 Croatia (local name: Hrvatska)
                      </option>
                      <option value="386">
                        +386 Slovenia
                      </option>
                      <option value="387">
                        +387 Bosnia and Herzegovina
                      </option>
                      <option value="389">
                        +389 Macedonia
                      </option>
                      <option value="39">
                        +39 Italy
                      </option>
                      <option value="39">
                        +39 Vatican City State (Holy See)
                      </option>
                      <option value="40">
                        +40 Romania
                      </option>
                      <option value="41">
                        +41 Switzerland
                      </option>
                      <option value="420">
                        +420 Czech Republic
                      </option>
                      <option value="421">
                        +421 Slovakia (Slovak Republic)
                      </option>
                      <option value="423">
                        +423 Liechtenstein
                      </option>
                      <option value="43">
                        +43 Austria
                      </option>
                      <option value="44">
                        +44 Guernsey
                      </option>
                      <option value="44">
                        +44 Isle of Man
                      </option>
                      <option value="44">
                        +44 Jersey
                      </option>
                      <option value="44">
                        +44 South Georgia and the South Sandwich Islands
                      </option>
                      <option value="44">
                        +44 United Kingdom
                      </option>
                      <option value="45">
                        +45 Denmark
                      </option>
                      <option value="46">
                        +46 Sweden
                      </option>
                      <option value="47">
                        +47 Bouvet Island
                      </option>
                      <option value="47">
                        +47 Norway
                      </option>
                      <option value="47">
                        +47 Svalbard and Jan Mayen Islands
                      </option>
                      <option value="48">
                        +48 Poland
                      </option>
                      <option value="49">
                        +49 Germany
                      </option>
                      <option value="493">
                        +493 Alderney
                      </option>
                      <option value="500">
                        +500 Falkland Islands (Malvinas)
                      </option>
                      <option value="501">
                        +501 Belize
                      </option>
                      <option value="502">
                        +502 Guatemala
                      </option>
                      <option value="503">
                        +503 El Salvador
                      </option>
                      <option value="504">
                        +504 Honduras
                      </option>
                      <option value="505">
                        +505 Nicaragua
                      </option>
                      <option value="506">
                        +506 Costa Rica
                      </option>
                      <option value="507">
                        +507 Panama
                      </option>
                      <option value="508">
                        +508 St. Pierre and Miquelon
                      </option>
                      <option value="509">
                        +509 Haiti
                      </option>
                      <option value="51">
                        +51 Peru
                      </option>
                      <option value="52">
                        +52 Mexico
                      </option>
                      <option value="53">
                        +53 Cuba
                      </option>
                      <option value="54">
                        +54 Argentina
                      </option>
                      <option value="55">
                        +55 Brazil
                      </option>
                      <option value="56">
                        +56 Chile
                      </option>
                      <option value="57">
                        +57 Colombia
                      </option>
                      <option value="58">
                        +58 Venezuela
                      </option>
                      <option value="590">
                        +590 Guadeloupe
                      </option>
                      <option value="590">
                        +590 Saint Barthelemy
                      </option>
                      <option value="590">
                        +590 Saint Martin
                      </option>
                      <option value="591">
                        +591 Bolivia
                      </option>
                      <option value="592">
                        +592 Guyana
                      </option>
                      <option value="593">
                        +593 Ecuador
                      </option>
                      <option value="594">
                        +594 French Guiana
                      </option>
                      <option value="595">
                        +595 Paraguay
                      </option>
                      <option value="596">
                        +596 Martinique
                      </option>
                      <option value="597">
                        +597 Suriname
                      </option>
                      <option value="598">
                        +598 Uruguay
                      </option>
                      <option value="599">
                        +599 Netherlands Antilles
                      </option>
                      <option value="60">
                        +60 Malaysia
                      </option>
                      <option value="61">
                        +61 Australia
                      </option>
                      <option value="61">
                        +61 Christmas Island
                      </option>
                      <option value="61">
                        +61 Cocos (Keeling) Islands
                      </option>
                      <option value="61">
                        +61 Heard and Mc Donald Islands
                      </option>
                      <option value="62">
                        +62 Indonesia
                      </option>
                      <option value="63">
                        +63 Philippines
                      </option>
                      <option value="64">
                        +64 New Zealand
                      </option>
                      <option value="65">
                        +65 Singapore
                      </option>
                      <option value="66">
                        +66 Thailand
                      </option>
                      <option value="670">
                        +670 East Timor
                      </option>
                      <option value="670">
                        +670 Timor-Leste
                      </option>
                      <option value="672">
                        +672 Antarctica
                      </option>
                      <option value="672">
                        +672 Norfolk Island
                      </option>
                      <option value="673">
                        +673 Brunei Darussalam
                      </option>
                      <option value="674">
                        +674 Nauru
                      </option>
                      <option value="675">
                        +675 Papua New Guinea
                      </option>
                      <option value="676">
                        +676 Tonga
                      </option>
                      <option value="677">
                        +677 Solomon Islands
                      </option>
                      <option value="678">
                        +678 Vanuatu
                      </option>
                      <option value="679">
                        +679 Fiji
                      </option>
                      <option value="680">
                        +680 Palau
                      </option>
                      <option value="681">
                        +681 Wallis And Futuna Islands
                      </option>
                      <option value="682">
                        +682 Cook Islands
                      </option>
                      <option value="683">
                        +683 Niue
                      </option>
                      <option value="684">
                        +684 American Samoa
                      </option>
                      <option value="685">
                        +685 Samoa
                      </option>
                      <option value="685">
                        +685 Western Sahara
                      </option>
                      <option value="686">
                        +686 Kiribati
                      </option>
                      <option value="687">
                        +687 New Caledonia
                      </option>
                      <option value="688">
                        +688 Tuvalu
                      </option>
                      <option value="689">
                        +689 French Polynesia
                      </option>
                      <option value="690">
                        +690 Tokelau
                      </option>
                      <option value="691">
                        +691 Micronesia
                      </option>
                      <option value="692">
                        +692 Marshall Islands
                      </option>
                      <option value="7">
                        +7 Kazakhstan
                      </option>
                      <option value="7">
                        +7 Russian Federation
                      </option>
                      <option value="81">
                        +81 Japan
                      </option>
                      <option value="82">
                        +82 South Korea
                      </option>
                      <option value="84">
                        +84 Vietnam
                      </option>
                      <option value="850">
                        +850 North Korea
                      </option>
                      <option value="852">
                        +852 Hong Kong
                      </option>
                      <option value="853">
                        +853 Macau
                      </option>
                      <option value="855">
                        +855 Cambodia
                      </option>
                      <option value="856">
                        +856 Lao People's Democratic Republic
                      </option>
                      <option value="86">
                        +86 China
                      </option>
                      <option value="872">
                        +872 Pitcairn
                      </option>
                      <option value="880">
                        +880 Bangladesh
                      </option>
                      <option value="886">
                        +886 Taiwan
                      </option>
                      <option value="90">
                        +90 Turkey
                      </option>
                      <option value="91">
                        +91 India
                      </option>
                      <option value="92">
                        +92 Pakistan
                      </option>
                      <option value="93">
                        +93 Afghanistan
                      </option>
                      <option value="94">
                        +94 Sri Lanka
                      </option>
                      <option value="95">
                        +95 Myanmar
                      </option>
                      <option value="960">
                        +960 Maldives
                      </option>
                      <option value="961">
                        +961 Lebanon
                      </option>
                      <option value="962">
                        +962 Jordan
                      </option>
                      <option value="963">
                        +963 Syrian Arab Republic
                      </option>
                      <option value="964">
                        +964 Iraq
                      </option>
                      <option value="965">
                        +965 Kuwait
                      </option>
                      <option value="966">
                        +966 Saudi Arabia
                      </option>
                      <option value="967">
                        +967 Yemen
                      </option>
                      <option value="968">
                        +968 Oman
                      </option>
                      <option value="970">
                        +970 Palestine
                      </option>
                      <option value="971">
                        +971 United Arab Emirates
                      </option>
                      <option value="972">
                        +972 Israel
                      </option>
                      <option value="973">
                        +973 Bahrain
                      </option>
                      <option value="974">
                        +974 Qatar
                      </option>
                      <option value="975">
                        +975 Bhutan
                      </option>
                      <option value="976">
                        +976 Mongolia
                      </option>
                      <option value="977">
                        +977 Nepal
                      </option>
                      <option value="98">
                        +98 Iran (Islamic Republic of)
                      </option>
                      <option value="992">
                        +992 Tajikistan
                      </option>
                      <option value="993">
                        +993 Turkmenistan
                      </option>
                      <option value="994">
                        +994 Azerbaijan
                      </option>
                      <option value="995">
                        +995 Georgia
                      </option>
                      <option value="996">
                        +996 Kyrgyzstan
                      </option>
                      <option value="998">
                        +998 Uzbekistan
                      </option>
                      <option value="">Other Country</option>
                    </select>
                  </div>
                </div>

                <mt-field class="menu-item" label="الهاتف الخلوي" v-model="mobile"  type="number" :attr="{ oninput: 'if(value.length>16)value=value.slice(6,16)' }" />
                <mt-field label="رمز التحقق" v-model="verifyCodeMobile" type="number" :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" >
                    <mt-button @click="sendVerifyCodeMobile" class="btn" type="default" size="small" plain>{{sendStateTextMobile}}</mt-button>
                </mt-field>
                <mt-button class="ds-button-large" type="primary" @click='updateMobile' >إرسال</mt-button>
            </div>
        </mt-popup>

        <!--修改邮箱-->
        <mt-popup v-model="editEmailVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header :title="(user.member_emailbind?'تعديل':'ربط')+' صندوق بريد'" class="common-header">
                    <mt-button slot="left" icon="back" @click="editEmailVisible=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <mt-field class="menu-item" label="صندوق بريد" type="text" v-model="email" />
                <mt-button class="ds-button-large"  type="primary" @click='sendVerifyCodeEmail' >قدم</mt-button>
            </div>
        </mt-popup>

        <!--修改登录密码-->
        <mt-popup v-model="editPasswordVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="تغيير كلمة المرور" class="common-header">
                    <mt-button slot="left" icon="back" @click="editPasswordVisible=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <mt-field class="menu-item" label="كلمة السر الجديدة" type="password" v-model="password1" />
                <mt-field class="menu-item" label="تأكيد كلمة المرور" type="password" v-model="password2" />
                <mt-button class="ds-button-large" type="primary" @click='updatePassword' >إرسال</mt-button>
            </div>
        </mt-popup>

        <!--修改支付密码-->
        <mt-popup v-model="editPaypwdVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="تغيير كلمة مرور الدفع" class="common-header">
                    <mt-button slot="left" icon="back" @click="editPaypwdVisible=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <mt-field class="menu-item" label="كلمة السر الجديدة" type="password" v-model="paypwd1" />
                <mt-field class="menu-item" label="تأكيد كلمة المرور" type="password" v-model="paypwd2" />
                <mt-button class="ds-button-large"  type="primary" @click='updatePaypwd'>إرسال</mt-button>
            </div>
        </mt-popup>

        <mt-popup v-model="sendAuthCode" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="المصادقة" class="common-header">
                    <mt-button slot="left" icon="back" @click="sendAuthCode=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <common-send-code @checkSuccess="checkSuccess" />
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'
import { logout, getMemberInfo } from '../../../api/member'
import CommonSendCode from '../common/CommonSendCode'
import { updateUserMobile, updateUserPassword, updateUserPaypwd, bindUserMobile, bindUserEmail } from '../../../api/memberSetting'
export default {
  components: {
    CommonSendCode
  },
  name: 'MemberSetting',
  data () {
    return {
      sendAuthCode: false,
      authType: 'mobile',
      editPaypwdVisible: false,
      paypwd1: '',
      paypwd2: '',
      editMobileVisible: false,
      mobile: '',
      editEmailVisible: false,
      email: '',
      editPasswordVisible: false,
      password1: '',
      password2: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: 'إرسال',
      canSendEmail: true,
      timeIntervalEmail: false,
      sendStateTextEmail: 'إرسال',
      nationalcode: 86
    }
  },
  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
    clearInterval(this.timeIntervalEmail)
  },
  created: function () {
    getMemberInfo().then(res => {
      this.memberUpdate({info:res.result.member_info})
      if (!res.result.member_info.member_emailbind) { // 如果没有绑定邮箱则输入项自动填写上次的邮箱
        this.email = res.result.member_info.member_email
      }
      if (!res.result.member_info.member_mobilebind) { // 如果没有绑定手机则输入项自动填写上次的手机
        this.mobile = res.result.member_info.member_mobile
      }
    }, error => {}
    )
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  methods: {
    ...mapMutations({
      memberUpdate: 'memberUpdate',
      memberEdit: 'memberEdit',
      memberLogout: 'memberLogout'
    }),
    logout () {
      logout(this.user.member_name).then(res => {
        this.memberLogout()
        this.$router.push({ name: 'HomeMemberLogin' })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    popupVisible (authType) {
      this.authType = authType
      switch (authType) {
        case 'mobile':
          if (this.user.member_mobilebind && this.user.member_mobile) { // 已绑定手机则需要验证
            this.sendAuthCode = true
          } else {
            this.editMobileVisible = true
          }
          break
        case 'email':
          if (this.user.member_emailbind && this.user.member_email) { // 已绑定邮箱则需要验证
            this.sendAuthCode = true
          } else {
            this.editEmailVisible = true
          }
          break
        case 'password':
          this.sendAuthCode = true
          break
        case 'paypwd':
          this.sendAuthCode = true
          break
      }
    },
    checkSuccess () {
      switch (this.authType) {
        case 'mobile':
          this.editMobileVisible = true
          break
        case 'email':
          this.editEmailVisible = true
          break
        case 'password':
          this.editPasswordVisible = true
          break
        case 'paypwd':
          this.editPaypwdVisible = true
          break
      }
    },
    // 更改绑定手机号
    updateMobile () {
      updateUserMobile(this.verifyCodeMobile).then(res => {
        this.memberEdit({ member_mobile: this.mobile, member_mobilebind: 1 })
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 更改登录密码
    updatePassword () {
      updateUserPassword(this.password1, this.password2).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 更改支付密码
    updatePaypwd () {
      updateUserPaypwd(this.paypwd1, this.paypwd2).then(res => {
        Toast(res.message)
        this.$router.go(0)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 发送手机验证码
    sendVerifyCodeMobile () {
      if (!this.canSendMobile) {
        return
      }
      bindUserMobile(this.mobile, this.nationalcode).then(res => {
        this.memberEdit({ member_mobile: this.mobile, member_mobilebind: 0 })
        this.canSendMobile = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
            _this.canSendMobile = true
            _this.sendStateTextMobile = 'إرسال'
            clearInterval(_this.timeIntervalMobile)
          }else{
              _this.sendStateTextMobile = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 发送邮箱验证码
    sendVerifyCodeEmail () {
      if (!this.canSendEmail) {
        return
      }
      bindUserEmail(this.email).then(res => {
        this.memberEdit({ member_email: this.email, member_emailbind: 0 })
        this.canSendEmail = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalEmail = setInterval(function () {
          if (second <= 0) {
            _this.canSendEmail = true
            _this.sendStateTextEmail = 'إرسال'
            clearInterval(_this.timeIntervalEmail)
          }else{
              _this.sendStateTextEmail = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  }
}
</script>

<style  lang="scss" scoped>
  .member-account-set {position:relative;z-index:100;
      .menu-list{
          .menu-item {
              .right-arrow{transform: rotate(-90deg);color:#ddd;font-size: .6rem;}
          }
      }
  }
  .national_code_box{
    padding: 0 10px;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .national_code_box .box_dt{
    -ms-flex: 1;
    flex: 1;
    width: 105px;
    -ms-flex: none;
    flex: none;
    font-size: 0.7rem;
  }
  .national_code_box .box_dd{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .national_code_box:after{
    content: "";
    position: absolute;
    z-index: 1;
    pointer-events: none;
    background-color: #e5e5e5;
    height: 1px;
    left: 0.4rem;
    right: 0.4rem;
    bottom: 0;
  }
  .national_code{
    width: 100%;
    background-color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: inherit;
    min-height: 48px;
    display: block;
    overflow: hidden;
    position: relative;
    text-decoration: none;
    border: none;
  }
</style>
